import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import { auth, database, messaging } from 'helpers/firebase'
import { initMessaging } from 'helpers/notifications'

import { withStyles } from 'material-ui/styles'

import Header from 'components/Header'
import LoadingSplash from 'components/LoadingSplash'
import SideNav from 'components/SideNav'
import EditDialog from 'components/EditDialog'
import PatchNotes from 'components/Dialogs/PatchNotes'
import Registration from 'views/Registration'

import { routes } from 'constants/routes'
import { userSchema } from 'constants/schemas'
import styles from 'styles/components/Main'

import { AppState } from 'helpers/context'

class Main extends React.Component {
  state = {
    pageTitle: 'Welcome',
    mobileOpen: false,
    courses: {},
    loading: true,
    initialLoad: true,
    userEdit: false
  }

  componentDidMount() {
    const { user } = this.props
    this.databaseRef = database.ref()

    this.databaseRef.on('value', snapshot => {
      if (snapshot.val() !== null) {
        const snap = snapshot.val()
        this.setState(
          {
            courses: snap.courses,
            providers: snap.providers,
            userState: snap.users[user.uid] || {},
            patches: snap.patches,
            currentPatch: snap.patches[snap.patches.length - 1]
          },
          () => {
            this.setState({ loading: false, initialLoad: false })
          }
        )
      } else {
        this.setState(
          { courses: {}, providers: {}, userState: {}, patches: [] },
          () => {
            this.setState({ loading: false, initialLoad: false })
          }
        )
      }
    })

    initMessaging()
  }

  componentWillUnmount() {
    this.databaseRef.off()
  }

  handleStartLoading = () => {
    this.setState({
      loading: true
    })
  }

  handleStopLoading = () => {
    this.setState({
      loading: false
    })
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen })
  }

  handleUpdateUser = ({ pin, ...user }) => {
    if (pin !== this.state.userState.pin) {
      database.ref().update({
        [`/users/${this.props.user.uid}/pin`]: pin
      })
    }

    auth.currentUser.updateProfile(user)
    this.setState({ userEdit: false })
  }

  handleCancelEditUser = () => {
    this.setState({ userEdit: false })
  }

  handleEditUser = () => {
    this.setState({ userEdit: true })
  }

  handleClosePatchNotes = () => {
    database
      .ref(`users/${this.props.user.uid}`)
      .update({ patch: process.env.REACT_APP_VERSION })
  }

  render() {
    window.state = this.state
    const {
      appTitle,
      courses,
      loading,
      initialLoad,
      mobileOpen,
      providers,
      userEdit,
      userState,
      currentPatch
    } = this.state
    const { classes, user } = this.props

    return (
      <Router>
        <AppState.Provider
          value={{
            state: this.state,
            startLoading: this.handleStartLoading,
            stopLoading: this.handleStopLoading
          }}
        >
          <div className={classes.root}>
            {loading && <LoadingSplash />}
            {!initialLoad &&
              (userState.registrationMode ? (
                <Registration userState={userState} courses={courses} />
              ) : (
                <div className={classes.appFrame}>
                  <Header
                    open={mobileOpen}
                    toggle={this.handleDrawerToggle}
                    title={appTitle}
                    user={user}
                    editUser={this.handleEditUser}
                  />
                  <SideNav
                    open={mobileOpen}
                    toggle={this.handleDrawerToggle}
                    user={user}
                    title={appTitle}
                  />
                  <main className={classes.content}>
                    {userEdit && (
                      <EditDialog
                        current={{ ...user, pin: userState.pin || '' }}
                        fields={userSchema}
                        title="Edit Account"
                        update={this.handleUpdateUser}
                        cancel={this.handleCancelEditUser}
                      />
                    )}
                    {userState.patch !== process.env.REACT_APP_VERSION && (
                      <PatchNotes
                        {...currentPatch}
                        onClose={this.handleClosePatchNotes}
                      />
                    )}
                    <Switch>
                      {routes.map(
                        ({ exact, icon, path, redirect, Screen, ...props }) =>
                          redirect ? (
                            <Route
                              key={path}
                              exact={exact}
                              path={path}
                              render={() => <Redirect to={redirect} />}
                            />
                          ) : (
                            <Route
                              key={path}
                              path={path}
                              exact={exact}
                              render={() => (
                                <Screen
                                  user={user}
                                  courses={courses}
                                  providers={providers}
                                  {...props}
                                />
                              )}
                            />
                          )
                      )}
                    </Switch>
                  </main>
                </div>
              ))}
          </div>
        </AppState.Provider>
      </Router>
    )
  }
}

export default withStyles(styles, { withTheme: true })(Main)



// WEBPACK FOOTER //
// ./src/components/Main.jsx